/* ============================================
   Don Chacho — Carrito JS (Drawer + Página)
   Archivo: assets/dc-cart.js
   ============================================ */
(function(){
  'use strict';

  var FREE_SHIPPING = 49900; // $499 MXN en centavos

  /* ================================================
     DRAWER
     ================================================ */
  var drawer = null;
  var overlay = null;

  function initDrawer() {
    drawer = document.querySelector('.dc-drawer');
    overlay = document.querySelector('.dc-drawer-overlay');
    if (!drawer || !overlay) return;

    // Cerrar al click en overlay
    overlay.addEventListener('click', closeDrawer);

    // Botón cerrar
    var closeBtn = drawer.querySelector('.dc-drawer__close');
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    // ESC
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  function openDrawer() {
    if (!drawer) return;
    refreshDrawer();
    drawer.classList.add('open');
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  function refreshDrawer() {
    fetch('/cart.js')
    .then(function(r){ return r.json(); })
    .then(function(cart) {
      renderDrawerItems(cart);
      updateEnvioBar(cart.total_price);
      updateCartCount(cart.item_count);
      updateSubtotal(cart.total_price);
    });
  }

  function renderDrawerItems(cart) {
    var container = drawer.querySelector('.dc-drawer__items');
    var countEl = drawer.querySelector('.dc-drawer__count');
    if (!container) return;

    if (countEl) countEl.textContent = cart.item_count + (cart.item_count === 1 ? ' producto' : ' productos');

    if (cart.item_count === 0) {
      container.innerHTML = '<div class="dc-drawer__empty"><div class="dc-drawer__empty-icon">🛒</div><p>Tu carrito está vacío</p><a class="dc-drawer__empty-link" href="/pages/comprar">Ver productos →</a></div>';
      return;
    }

    container.innerHTML = cart.items.map(function(item) {
      var color = getChileColor(item.product_type, item.title);
      return '<div class="dc-drawer__item" data-line="' + item.key + '">' +
        '<div class="dc-drawer__item-img" style="background:' + color + '">' +
        (item.image ? '<img src="' + item.image + '" alt="' + item.title + '" loading="lazy">' : '<span class="dc-drawer__item-letter">' + item.title.charAt(0) + '</span>') +
        '</div>' +
        '<div class="dc-drawer__item-info">' +
        '<div class="dc-drawer__item-nombre">' + item.product_title + '</div>' +
        '<div class="dc-drawer__item-variante">' + (item.variant_title || '') + '</div>' +
        '<div class="dc-drawer__item-bottom">' +
        '<div class="dc-drawer__item-qty">' +
        '<button class="dc-drawer__item-qty-btn" data-action="minus" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '">−</button>' +
        '<span class="dc-drawer__item-qty-num">' + item.quantity + '</span>' +
        '<button class="dc-drawer__item-qty-btn" data-action="plus" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '">+</button>' +
        '</div>' +
        '<span class="dc-drawer__item-precio">' + formatMoney(item.line_price) + '</span>' +
        '</div>' +
        '<button class="dc-drawer__item-remove" data-key="' + item.key + '">Eliminar</button>' +
        '</div></div>';
    }).join('');

    // Eventos qty y remove
    container.querySelectorAll('.dc-drawer__item-qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = btn.getAttribute('data-key');
        var qty = parseInt(btn.getAttribute('data-qty'));
        updateItemQty(key, Math.max(0, qty));
      });
    });
    container.querySelectorAll('.dc-drawer__item-remove').forEach(function(btn) {
      btn.addEventListener('click', function() {
        updateItemQty(btn.getAttribute('data-key'), 0);
      });
    });
  }

  function updateItemQty(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r){ return r.json(); })
    .then(function(cart) {
      renderDrawerItems(cart);
      updateEnvioBar(cart.total_price);
      updateCartCount(cart.item_count);
      updateSubtotal(cart.total_price);
    });
  }

  function updateEnvioBar(totalCentavos) {
    var prog = drawer ? drawer.querySelector('.dc-drawer__envio-prog') : null;
    var texto = drawer ? drawer.querySelector('.dc-drawer__envio-texto') : null;
    var pct = Math.min(100, Math.round((totalCentavos / FREE_SHIPPING) * 100));
    if (prog) prog.style.width = pct + '%';
    if (texto) {
      if (totalCentavos >= FREE_SHIPPING) {
        texto.innerHTML = '🎉 <strong>¡Envío gratis!</strong> Tu pedido califica';
      } else {
        var falta = formatMoney(FREE_SHIPPING - totalCentavos);
        texto.innerHTML = '🚚 Te faltan <strong>' + falta + '</strong> para envío gratis';
      }
    }
  }

  function updateSubtotal(totalCentavos) {
    var el = drawer ? drawer.querySelector('.dc-drawer__subtotal-monto') : null;
    if (el) el.textContent = formatMoney(totalCentavos) + ' MXN';
  }

  /* ================================================
     PÁGINA /CART
     ================================================ */
  function initCartPage() {
    var cartPage = document.querySelector('.dc-cart');
    if (!cartPage) return;

    // Qty buttons
    cartPage.querySelectorAll('.dc-cart__item-qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = btn.closest('.dc-cart__item');
        var key = item.getAttribute('data-key');
        var qtyEl = item.querySelector('.dc-cart__item-qty-num');
        var current = parseInt(qtyEl.textContent);
        var newQty = btn.classList.contains('dc-cart__item-qty-btn--minus') ? current - 1 : current + 1;
        updateCartPageItem(key, Math.max(0, newQty));
      });
    });

    // Remove buttons
    cartPage.querySelectorAll('.dc-cart__item-remove').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = btn.closest('.dc-cart__item');
        updateCartPageItem(item.getAttribute('data-key'), 0);
      });
    });

    // Upsell add
    cartPage.querySelectorAll('.dc-cart__up-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;
        var orig = btn.textContent;
        btn.textContent = '✓';
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
        .then(function(r){ return r.json(); })
        .then(function() { window.location.reload(); })
        .catch(function() { btn.textContent = orig; btn.disabled = false; });
      });
    });
  }

  function updateCartPageItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(){ window.location.reload(); });
  }

  /* ================================================
     HELPERS
     ================================================ */
  function formatMoney(centavos) {
    return '$' + (centavos / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function getChileColor(type, title) {
    var t = (title + ' ' + type).toLowerCase();
    if (t.includes('habanero')) return '#F4BD34';
    if (t.includes('serrano')) return '#3B9E52';
    if (t.includes('güero') || t.includes('guero')) return '#ECE735';
    if (t.includes('ponch')) return '#ED5F36';
    if (t.includes('ana sexy')) return '#8D3092';
    if (t.includes('betty')) return '#12A7BC';
    return '#D12D3B';
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function(el){
      el.textContent = count;
    });
  }

  /* ================================================
     INTERCEPTAR "AGREGAR AL CARRITO"
     Abrir drawer automáticamente al agregar
     ================================================ */
  function interceptAddToCart() {
    // Escuchar cualquier fetch a /cart/add.js hecho por otros scripts
    var origFetch = window.fetch;
    window.fetch = function(url) {
      var result = origFetch.apply(this, arguments);
      if (typeof url === 'string' && url.includes('/cart/add.js')) {
        result.then(function(r) {
          if (r.ok) setTimeout(openDrawer, 300);
          return r;
        });
      }
      return result;
    };
  }

  /* ================================================
     INIT
     ================================================ */
  document.addEventListener('DOMContentLoaded', function() {
    initDrawer();
    initCartPage();
    interceptAddToCart();

    // Botón del nav que abre el drawer
    document.querySelectorAll('[data-open-cart]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        openDrawer();
      });
    });
  });

  // Exponer openDrawer globalmente por si otros scripts lo necesitan
  window.dcOpenCart = openDrawer;
})();